export const defualtMeta = {
    title : '그레이트프로 - 금융 IT 얼라이언스 플랫폼',
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          'GREAT PRO 단순 매칭이 아닌 성과와 커리어, 삶을 함께 설계하는 금융 IT 얼라이언스 플랫폼입니다. 검증된 IT 프리랜서와 기업이 함께 성장하는 파트너십을 경험하세요.',
      },
      {
        vmid: 'keywords',
        name: 'keywords',
        content: 'IT엔터테인먼트, 금융IT인재 매칭 플랫폼, greatpro, 그레이트프로, 프로엔, 프로엔솔루션, 금융IT인재, 금융IT개발, 금융개발, 금융IT프로젝트, 금융프로젝트, 금융IT취업, 프리랜서, 프리랜서사이트, 프리랜서개발자, 외주, 개발자, 개발자외주, 개발자프리랜서, 프로그램개발, 웹개발자, 앱개발, 어플개발, 어플리케이션, 금융업무, 전문인력, 전문가, IT인재관리, 인재관리',
      },
    ]
    
    // {
    //   vmid: 'author',
    //   name: 'author',
    //   content: 'pozafly',
    // },
  };

export const mainMeta = {
  title : 'IT 프리랜서 매칭을 넘어선 금융 IT 얼라이언스 플랫폼｜그레이트프로',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        'GREAT PRO 단순 매칭이 아닌 성과와 커리어, 삶을 함께 설계하는 금융 IT 얼라이언스 플랫폼입니다. 검증된 IT 프리랜서와 기업이 함께 성장하는 파트너십을 경험하세요.',
    },
  ],
  link : [
    {
      rel : 'canonical',
      href : 'https://www.greatpro.co.kr'
    }
  ]
};

export const projectSearchMeta = {
  title : '검증된 금융 IT 프로젝트 찾기 | IT 인재 매칭 얼라이언스 플랫폼 그레이트프로',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        '전문성과 신뢰를 갖춘 금융 IT 프로젝트를 지금 만나보세요. GREAT PRO는 커리어 성장을 위한 IT프로 맞춤형 프로젝트만을 연결합니다.',
    },
  ],
  link : [
    {
      rel : 'canonical',
      href : 'https://www.greatpro.co.kr/itpro/project/search'
    }
  ]
};

export const projectDetailMeta = (projectNm, projectSeq, locCont, techCont) => {
  return {
    title : `${projectNm} - 그레이트 프로`,
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          `${locCont}, ${techCont} – 검증된 금융 IT 프로젝트, 그레이트프로`,
      },
    ],
    link : [
      {
        rel : 'canonical',
        href : `https://www.greatpro.co.kr/project/detail?projectSeq=${projectSeq}`
      }
    ]
  }
};

export const itproSearchMeta = {
  title : '검증된 금융 IT 프로 인재 찾기 | GREAT PRO',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        'GREAT PRO는 단순 매칭이 아닌, 4단계 검증 시스템을 통과한 금융 IT 프리랜서만 연결합니다. 신뢰 기반 얼라이언스 구조로 프로젝트 성과까지 함께 책임집니다.'
    },
  ],
  link : [
    {
      rel : 'canonical',
      href : 'https://www.greatpro.co.kr/client/itpro/search'
    }
  ]
};

export const serviceMeta = {
  title : '성과와 커리어를 함께 설계하는 금융 IT 얼라이언스 플랫폼 | 그레이트프로',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        '단순 매칭이 아닌, 금융 IT 전문가와 기업이 함께 성장하는 얼라이언스. 커리어 설계부터 라이프케어까지, GREAT PRO는 성공을 위한 새로운 기준을 제시합니다.'
    },
  ],
  link : [
    {
      rel : 'canonical',
      href : 'https://www.greatpro.co.kr/service'
    }
  ]
};

export const academyMeta = {
  title : '국내 최초 금융 IT 실전 부트캠프 | 그레이트프로 아카데미 ‘위대한 고래’',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        '금융 IT 레전드가 직접 가르치는 국내 최초의 실전 부트캠프! 도메인 지식부터 AI 협업까지, 그레이트프로만의 독자 시스템으로 퀄리티 금융 개발자를 육성합니다.'
    },
    {
      property: 'og:title',
      content:
        '위대한 금융 IT 실전 교육, 그레이트프로 아카데미 "위대한 고래"'
    },
    {
      property: 'og:description',
      content:
        '금융 IT 실전 현장을 그대로 옮긴 독자적 교육 시스템. 금융 도메인부터 협업툴, AI 실습까지, 퀄리티 IT프로를 위한 무료 부트캠프에 지금 초대합니다.'
    },
  ],
  link : [
    {
      rel : 'canonical',
      href : 'https://www.greatpro.co.kr/great-academy'
    }
  ]
};

export const communityMeta = {
  title : '그레이트프로 커뮤니티 | 금융 IT프로를 위한 소식과 인사이트',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        '금융 IT프로들을 위한 그레이트프로의 공식 소식과 업계 인사이트를 한곳에. 서비스 업데이트, 정책 변경, 시스템 개선 등 중요한 안내를 전달합니다.'
    },
  ]
    
};

export const noticeMeta = {
  title : '공지사항 | 금융IT 인재 매칭 얼라이언스 플랫폼 그레이트프로',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        'GREAT PRO의 최신 소식과 공지사항을 확인하세요. 서비스 변경, 시스템 점검, 회원 대상 안내 등 신뢰할 수 있는 정보를 제공합니다.'
    },
  ]
};
 
export const noticeDetailMeta = (title, metaContData) => {
  return {
    title : `${title} | 그레이트프로 공지사항`,
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          `${metaContData}`,
      },
    ]
  }
}; 

export const newsMeta = {
  title : '뉴스 | 금융IT 인재 매칭 얼라이언스 플랫폼 그레이트프로',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        '금융 IT 얼라이언스 생태계를 만들어가는 GREAT PRO의 언론 보도, 캠페인, 브랜드 활동을 확인하세요. 전문가와 기업이 함께하는 얼라이언스의 이야기를 들려드립니다.',
    },
  ]
};

export const newsDetailMeta = (title, metaContData) => {
  return {
    title : `${title} | 그레이트프로 뉴스`,
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          `${metaContData}`,
      },
    ]
  }
};

export const brandMeta = {
  title : '대한민국 최초 금융 IT 얼라이언스 플랫폼 | 그레이트프로의 철학과 비전',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        'GREAT PRO는 성과, 커리어, 삶을 잇는 금융 IT 프리랜서 생태계를 만들어갑니다. 매칭을 넘어선 얼라이언스라는 새로운 패러다임을 확인해보세요.'
    },
  ]
};

export const termsMeta = {
  title : '금융IT 인재 매칭 얼라이언스 플랫폼 그레이트프로 이용약관',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        '그레이트프로의 공식 이용약관을 확인하세요. 전문가와 기업 모두의 신뢰를 위한 플랫폼 이용 기준과 권리·의무를 명확히 안내합니다.'
    },
  ]
};

export const policyMeta = {
  title : '금융IT 인재 매칭 얼라이언스 플랫폼 그레이트프로 개인정보 처리방침',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        '그레이트프로의 공식 개인정보 처리방침을 확인하세요. 전문가와 기업 모두의 신뢰를 위한 개인정보 처리방침을 명확히 안내합니다.'
    },
  ]
};

export const howtouseMeta = {
  title : 'GREAT PRO 서비스 한눈에 보기 | IT프로와 기업을 위한 얼라이언스',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        '단순한 인력 매칭이 아닙니다. 그레이트프로는 금융 IT 전문가와 기업이 함께 성장하는 얼라이언스 플랫폼입니다. 신뢰성 높은 프로젝트와 검증된 IT프로들을 연결하여 성공을 위한 새로운 기준을 제시합니다.'
    },
  ]
};

export const itproGuideMeta = {
  title : 'IT프로 이용 가이드 | 커리어·라이프케어까지 책임지는 그레이트프로',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        '프로젝트 매칭을 넘어, 커리어 성장과 삶의 질까지 책임지는 플랫폼. GREAT PRO를 통해 IT 프로가 누릴 수 있는 얼라이언스 시스템을 안내합니다.'
    },
  ]
};

export const clientGuideMeta = {
  title : '클라이언트를 위한 그레이트프로 이용안내',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        '성과를 보장받는 금융 IT 프로젝트를 위해 GREAT PRO는 어떤 구조로 작동하는지 확인하세요. 검증된 전문가 연결부터 계약·관리까지 한눈에 안내해드립니다.'
    },
  ]
};

export const vendorGuideMeta = {
  title : '파트너사를 위한 그레이트프로 이용안내',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        'GREAT PRO와 함께하는 파트너사는 영업 부담 없이 검증된 프로젝트를 수주하고, 인재 운영에 집중할 수 있습니다. 책임 분담과 성과 공유의 구조를 소개합니다.'
    },
  ]
};

export const pricingMeta = {
  title : '이용요금 안내 | 그레이트프로 - 금융 IT 얼라이언스 플랫폼',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        '금융IT 인재 매칭 플랫폼 그레이트프로의 프로젝트 계약 관련 요금과 서비스 이용요금 안내입니다. 11년간 단 한 건의 분쟁 없이 운영된 신뢰 기반 시스템으로, 기업과 전문가 모두 안심하고 이용할 수 있습니다.'
    },
  ]
};

export const pointMeta = {
  title : 'GREAT PRO 포인트 사용 안내 | 플랫폼 혜택 및 이용 방식',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        '금융IT인재 매칭 얼라이언스 플랫폼 그레이트프로 서비스 회원을 위한 포인트 제도 안내입니다.'
    },
  ]
};

export const contactMeta = {
  title : '문의하기 | 금융IT 인재 매칭 얼라이언스 플랫폼 그레이트프로',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        '그레이트프로는 신뢰 기반의 파트너십을 지향합니다. 플랫폼 이용, 기업 제휴, IT프로 커리어 관련 문의를 남겨주시면 확인 후 안내드립니다.'
    },
  ]
};

export const loginMeta = {
  title : '로그인 | 금융IT 인재 매칭 얼라이언스 플랫폼 그레이트프로',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        '검증된 금융 IT프로와 함께하는 신뢰 기반 얼라이언스 플랫폼, 그레이트프로에 로그인하세요. 지금, 커리어 성장과 삶의 질 향상을 동시에 경험해보세요.'
    },
  ]
};

export const accountMeta = {
  title : '회원가입 | 그레이트프로 - 금융IT 전문가를 위한 얼라이언스 플랫폼',
  meta : [
    {
      vmid: 'description',
      name: 'description',
      content:
        '지금 회원가입하고 신뢰받는 전문가 얼라이언스에 합류하세요. 단순 매칭을 넘어 커리어 성장과 삶의 질을 함께 설계하는 플랫폼입니다.'
    },
  ]
};

export const eventMeta = {
    title : '그레이트프로 이벤트 | 금융IT 인재 매칭 얼라이언스 플랫폼 그레이트프로',
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          '금융IT 인재 매칭 플랫폼 그레이트프로 서비스 회원을 위한 이벤트 안내입니다.'
      },
    ]
};

export const findIdMeta = {
    title : '아이디 찾기 | 금융IT 인재 매칭 얼라이언스 플랫폼 그레이트프로',
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          '가입하신 회원 유형을 선택하고 본인 인증을 완료하면 아이디를 확인할 수 있습니다. 금융 IT 프리랜서를 위한 신뢰 기반 커리어 플랫폼, 그레이트프로.'
      },
      {
        vmid: 'robots',
        name: 'robots',
        content: 'noindex, nofollow'
      }
    ]
};

export const findPwMeta = {
    title : '비밀번호 찾기 | 금융IT 인재 매칭 얼라이언스 플랫폼 그레이트프로',
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          '가입한 아이디를 입력하면 비밀번호 재설정 절차가 시작됩니다. 그레이트프로는 금융 IT 전문가의 계정을 안전하게 보호합니다.'
      },
      {
        vmid: 'robots',
        name: 'robots',
        content: 'noindex, nofollow'
      }
    ]
};

export const resetPwMeta = {
    title : '비밀번호 재설정 | 금융IT 인재 매칭 얼라이언스 플랫폼 그레이트프로',
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          '잊어버린 비밀번호를 안전하게 재설정하세요. 그레이트프로는 전문가 회원의 정보를 보호하기 위해 안전하고 신뢰할 수 있는 인증 시스템을 제공합니다.'
      },
      {
        vmid: 'robots',
        name: 'robots',
        content: 'noindex, nofollow'
      }
    ]
};

export const findIdResultMeta = {
    title : '아이디 찾기 결과 | 금융IT 인재 매칭 얼라이언스 플랫폼 그레이트프로',
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          '입력하신 정보를 기준으로 아이디 찾기 결과를 확인하실 수 있습니다. 그레이트프로는 신뢰 기반의 플랫폼으로, 철저한 본인 확인을 통해 회원 정보를 안전하게 제공합니다.'
      },
      {
        vmid: 'robots',
        name: 'robots',
        content: 'noindex, nofollow'
      }
    ]
};

export const findPwAuthMeta = {
    title : '비밀번호 찾기 본인인증 | 금융IT 인재 매칭 얼라이언스 플랫폼 그레이트프로',
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          '본인 인증을 통해 비밀번호 재설정이 가능합니다. 안전하고 신뢰할 수 있는 금융 IT 얼라이언스 플랫폼, 그레이트프로.'
      },
      {
        vmid: 'robots',
        name: 'robots',
        content: 'noindex, nofollow'
      }
    ]
};

export const findAccountTypeMeta = {
    title : '아이디 찾기 | 금융IT 인재 매칭 얼라이언스 플랫폼 그레이트프로',
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          '정확한 계정 확인을 위해 회원 유형을 먼저 선택해 주세요. 그레이트프로는 금융 IT 전문가와 기업 모두의 계정을 안전하게 보호합니다.'
      },
      {
        vmid: 'robots',
        name: 'robots',
        content: 'noindex, nofollow'
      }
    ]
};

export const signupTermsMeta = {
    title : '회원가입 - 약관 동의 | 그레이트프로',
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          '이용약관과 개인정보 처리방침에 동의하고 다음 단계로 이동하세요. 그레이트프로는 모든 회원의 권리를 존중하며 정직한 운영을 약속합니다.'
      },
      {
        vmid: 'robots',
        name: 'robots',
        content: 'noindex, nofollow'
      }
    ]
};

export const signupVerifyMeta = {
    title : '회원가입 - 본인인증 | 그레이트프로',
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          '안전한 가입을 위해 본인 인증 절차를 진행해 주세요. 그레이트프로는 신뢰할 수 있는 금융 IT 생태계를 만듭니다.'
      },
      {
        vmid: 'robots',
        name: 'robots',
        content: 'noindex, nofollow'
      }
    ]
};

export const signupInfoMeta = {
    title : '회원가입 - 정보입력 | 그레이트프로',
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          '기본 정보를 입력해 계정을 생성하세요. 그레이트프로는 금융 IT 프리랜서와 기업 모두를 위한 검증된 플랫폼입니다'
      },
      {
        vmid: 'robots',
        name: 'robots',
        content: 'noindex, nofollow'
      }
    ]
};

export const updateInfoMeta = {
    title : '내 계정 관리 | 그레이트프로',
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          'GREAT PRO 단순 매칭이 아닌 성과와 커리어, 삶을 함께 설계하는 금융 IT 얼라이언스 플랫폼입니다. 검증된 IT 프리랜서와 기업이 함께 성장하는 파트너십을 경험하세요.'
      },
      {
        vmid: 'robots',
        name: 'robots',
        content: 'noindex, nofollow'
      }
    ]
};



export const signupCompleteMeta = {
    title : '회원가입 완료 | 그레이트프로 - 금융 IT 전문가 얼라이언스',
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          '그레이트프로에 합류하신 것을 환영합니다. 지금 이력서를 등록하고, 신뢰 기반의 프로젝트와 커리어를 연결해 보세요'
      },
      {
        vmid: 'robots',
        name: 'robots',
        content: 'noindex, nofollow'
      }
    ]
};

export const signupDeleteAccountMeta = {
    title : '회원탈퇴 | 그레이트프로',
    meta : [
      {
        vmid: 'description',
        name: 'description',
        content:
          '그레이트프로 탈퇴 절차를 진행하실 수 있습니다. IT 전문가의 가치와 신뢰를 우선하는 플랫폼으로 언제든 다시 돌아오실 수 있습니다.'
      },
      {
        vmid: 'robots',
        name: 'robots',
        content: 'noindex, nofollow'
      }
    ]
};